import ApplicationController from './application_controller'
import { animate } from 'animejs'

// Animations require the elementTarget to be styled with position relative or absolute
export default class extends ApplicationController {

	static targets = [ 'element', 'selectorInput' ]

	static values = {
		onlyActiveInputs: { type: Boolean, default: true },
		animated: { type: Boolean, default: true },
	}

	connect() {
		const selectedElement = this.getActiveElement()
		this.showElement(selectedElement)

		if (this.onlyActiveInputsValue) {
			this.disableInputs()
			this.enableInputs(selectedElement)
		}
	}

	switchElement(event) {
		this.hideElements()

		const nextElementId = event.params.nextElementId
		const nextElement = document.getElementById(nextElementId)
		this.showElement(nextElement)

		if (this.onlyActiveInputsValue) {
			this.disableInputs()
			this.enableInputs(nextElement)
		}
	}

	hideElements() {
		if (this.animatedValue) {
			const elementsToHide = this.elementTargets
				.filter(element => !element.classList.contains('d-none'))

			animate(elementsToHide, {
				left: '-240px',
				opacity: 0,
				duration: 400,
				easing: 'easeOutQuad',
				onComplete: () => { elementsToHide.forEach(e => e.classList.add('d-none')) }
			})
		} else {
			this.elementTargets.forEach(element => element.classList.add('d-none'))
		}
	}

	showElement(element) {
		const elementsToHide = this.elementTargets

		if (this.animatedValue) {
			element.style.left = '240px'
			animate(element, {
				left: '0px',
				opacity: 1,
				delay: 400,
				duration: 400,
				easing: 'easeOutQuad',
				onBegin: () => {
					elementsToHide.forEach( e => e.classList.add('d-none') )
					element.classList.remove('d-none')
				}
			})
		} else {
			this.elementTargets.forEach( e => e.classList.add('d-none') )
			element.classList.remove('d-none')
		}
	}

	disableInputs() {
		this.elementTargets.forEach(element => {
			Array.from(element.querySelectorAll('input, select'))
				.forEach(i => i.disabled = true)
		})
	}

	enableInputs(element) {
		Array.from(element.querySelectorAll('input, select'))
			.forEach(e => e.disabled = false)
	}

	getActiveElement() {
		if (this.selectorInputTargets.every(e => e.type == 'radio')) {
			const selectedInput = this.selectorInputTargets
				.find(i => i.checked)

			const nextElementId = selectedInput.dataset.elementSwitcherNextElementIdParam
			return document.getElementById(nextElementId)
		}
	}
}
